export const calcPackageTotalPrice = (serviceList, totalPrice, promotion) => {
  if (!serviceList) {
    return totalPrice;
  }
  let unselectedServicesTotalPrice = 0;
  if (promotion) {
    const { promoDiscountAmt, promoType } = promotion;
    let discountedTotalPrice = totalPrice;
    if (promoType === 'currencyApptDiscount') {
      discountedTotalPrice = Math.max(
        0,
        discountedTotalPrice - promoDiscountAmt
      );
    } else if (promoType === 'percentApptDiscount') {
      discountedTotalPrice =
        (discountedTotalPrice * (100 - promoDiscountAmt)) / 100;
    } else if (promoType) {
      serviceList.forEach(service => {
        const unselectedByDefault =
          service.isSelected === undefined &&
          service.selectable &&
          !service.selectByDefault;
        if (service.isSelected === false || unselectedByDefault) {
          unselectedServicesTotalPrice += service.promotion
            ? service.discountedPrice
            : service.price;
        }
        if (service.promotion) {
          discountedTotalPrice -= service.price - service.discountedPrice;
        }
      });
      discountedTotalPrice -= unselectedServicesTotalPrice;
    }
    return discountedTotalPrice;
  } else {
    serviceList.forEach(service => {
      const unselectedByDefault =
        service.isSelected === undefined &&
        service.selectable &&
        !service.selectByDefault;
      if (service.isSelected === false || unselectedByDefault) {
        unselectedServicesTotalPrice += service.price;
      }
    });
    return totalPrice - unselectedServicesTotalPrice;
  }
};

export const canPriceCapApplyToPackage = menuType => {
  if (!menuType) {
    return false;
  }
  return +menuType.totalPriceType > 0 && +menuType.totalPriceType <= 2;
};



// WEBPACK FOOTER //
// ./src/utils/prices.js